// extracted by mini-css-extract-plugin
export var cookieNotice = "CookieNotice-module--cookie-notice--1I4BX";